import React from 'react';
import styles from './style.module.less';

function Footer() {
    const jumpToICP = ()=>{
        window.open("https://beian.miit.gov.cn/")
    }
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <p className={styles.copyright}>© 2026 山海智算（上海）科技有限公司 版权所有</p>
        <p className={styles.icp} onClick={()=>jumpToICP()}>沪ICP备2025148263号-2</p>
      </div>
    </footer>
  );
}

export default Footer;
